import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SubscriptionComponent } from '../shared/helpers/subscription.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RouterOutlet,
    ],
})
export class ContentComponent extends SubscriptionComponent {
}
